import recovery from "@/store/app/google/recovery/recovery";
import users from './google/seat-management/user'
import sharedDrives from './google/seat-management/sharedDrive'
import classrooms from './google/seat-management/classroom'
import stats from "@/store/app/google/stats";
import report from "@/store/app/google/report";
import userReport from "@/store/app/google/userReport";
import backups from "@/store/app/google/backups";
import backupSettings from "@/store/app/google/seat-management/backupsettings";
import backupSettingsSharedDrive from "@/store/app/google/seat-management/shared-drive/backupsettings";
import backupSettingsClassroom from "@/store/app/google/seat-management/classroom/backupsettings";
import allEventLogs from "@/store/app/google/activity-logs/allEventLogs";
import webActivityLogs from "@/store/app/google/activity-logs/webActivityLogs";
import editDomain from "@/store/app/google/editDomain";
import backedUpItems from "@/store/app/google/activity-logs/backedUpItems";
import backupsByDay from "@/store/app/google/activity-logs/backupEventsByDay";
import backupItems from "@/store/app/google/activity-logs/backupItems";
import settings from "@/store/app/google/settings";

const defaultState = () => ({})

export default {
  namespaced: true,

  actions: {},

  modules: {
    recovery: recovery,
    users: users,
    sharedDrives: sharedDrives,
    classrooms,
    stats: stats,
    report,
    userReport,
    backups,
    backupSettings,
    backupSettingsSharedDrive,
    backupSettingsClassroom,
    allEventLogs,
    webActivityLogs,
    editDomain,
    backedUpItems,
    backupsByDay,
    backupItems,
    settings
  }
}
